import axios, { AxiosResponse } from 'axios';

export interface IisinZmena {
    cval?: string;
    duvod?: string;
    jmeno?: string;
    prijmeni?: string;
    isin?: string;
}

interface subj {
    subj: IisinZmena[];
}

interface c2 {
    c2: subj;
}

export interface isin {
    isin: c2;
}

const zadostZmenaApi = (
    method: 'GET' | 'POST' | 'PUT',
    idzadosti: number,
    type: 'Zmena' | 'Zruseni',
    step?: 'Zmena' | 'Zruseni',
    data?: IisinZmena
) => {
    return axios({
        method: method,
        url: `Zadosto${type}ISIN/${idzadosti}${step ? '/' + step : ''}`,
        ...((method === 'PUT' || method === 'POST') && {
            data: data
        })
    }).then((resp: AxiosResponse<IisinZmena>) => resp.data);
};

export default zadostZmenaApi;
